if (!customElements.get('product-card-swatches')) {
  customElements.define(
    'product-card-swatches',
    class ProductCardSwatches extends HTMLElement {
      connectedCallback() {
        this.variants = JSON.parse(this.dataset.variants || '[]');
        this.variantInput = this.querySelector('[name="id"]');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton?.querySelector('span');
        this.groups = Array.from(this.querySelectorAll('[data-option-index]'));
        this.cardWrapper = this.closest('.card-wrapper');
        this.primaryImage = this.cardWrapper?.querySelector('.card__media img:first-child');

        this.syncSelectionToCurrentVariant();

        this.groups.forEach((group) => {
          group.addEventListener('click', (event) => {
            const button = event.target.closest('[data-option-value]');
            if (!button || button.disabled) return;

            group.querySelectorAll('[data-option-value]').forEach((item) => {
              const selected = item === button;
              item.classList.toggle('is-selected', selected);
              item.setAttribute('aria-pressed', selected);
            });

            this.updateSelectedVariant();
          });
        });

        this.updateSelectedVariant();
      }

      syncSelectionToCurrentVariant() {
        const currentVariant =
          this.variants.find((variant) => String(variant.id) === this.variantInput?.value) ||
          this.variants.find((variant) => variant.available) ||
          this.variants[0];

        if (!currentVariant) return;

        this.groups.forEach((group) => {
          const optionIndex = Number(group.dataset.optionIndex);
          const selectedValue = currentVariant.options[optionIndex];

          group.querySelectorAll('[data-option-value]').forEach((button) => {
            const selected = button.dataset.optionValue === selectedValue;
            button.classList.toggle('is-selected', selected);
            button.setAttribute('aria-pressed', selected ? 'true' : 'false');
          });
        });
      }

      selectedOptions() {
        const selectedOptions = [];
        this.groups.forEach((group) => {
          selectedOptions[Number(group.dataset.optionIndex)] = group.querySelector('.is-selected')?.dataset.optionValue;
        });
        return selectedOptions;
      }

      updateSelectedVariant() {
        const selectedOptions = this.selectedOptions();
        const selectedVariant = this.variants.find((variant) =>
          variant.options.every((option, index) => option === selectedOptions[index])
        );

        this.updateAvailability(selectedOptions);

        if (!selectedVariant) {
          this.toggleSubmit(true, window.variantStrings?.unavailable || 'Unavailable');
          return;
        }

        this.variantInput.value = selectedVariant.id;
        this.updateCardImage(selectedVariant);
        this.toggleSubmit(!selectedVariant.available, selectedVariant.available ? window.variantStrings?.addToCart : window.variantStrings?.soldOut);
      }

      updateAvailability(selectedOptions) {
        this.groups.forEach((group) => {
          const optionIndex = Number(group.dataset.optionIndex);

          group.querySelectorAll('[data-option-value]').forEach((button) => {
            const candidate = [...selectedOptions];
            candidate[optionIndex] = button.dataset.optionValue;
            const hasVariant = this.variants.some((variant) =>
              variant.available && variant.options.every((option, index) => option === candidate[index])
            );

            button.classList.toggle('is-unavailable', !hasVariant);
            button.disabled = !hasVariant;
          });
        });
      }

      toggleSubmit(disabled, text) {
        if (!this.submitButton) return;

        if (disabled) {
          this.submitButton.setAttribute('disabled', 'disabled');
          this.submitButton.setAttribute('aria-disabled', true);
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButton.removeAttribute('aria-disabled');
        }

        if (text && this.submitButtonText) this.submitButtonText.textContent = text;
      }

      updateCardImage(variant) {
        const image = variant?.featured_image;
        if (!this.primaryImage || !image?.src) return;

        const separator = image.src.includes('?') ? '&' : '?';
        this.primaryImage.src = `${image.src}${separator}width=533`;
        this.primaryImage.srcset = '';
        if (image.alt) this.primaryImage.alt = image.alt;

        document.dispatchEvent(new CustomEvent('mariashop:card-options-updated'));
      }
    }
  );
}
